// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadWishListLines,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";

export const XngDispatchCompleteLoadWishListLines: any = (props: any) => {
    // XNG-Changes: skip reset
    if (!props.parameter.skipResetWishLists) {
        props.dispatch({
            type: "Data/WishLists/ResetDataViews",
        });
    }

    props.dispatch({
        type: "Pages/MyListDetails/CompleteLoadProductInfos",
        productInfosByWishListLineId: props.productInfosByWishListLineId,
    });

    props.dispatch({
        type: "Pages/MyListDetails/CompleteReplacementLoadProductInfos",
        replacementProductInfosByWishListLineId: props.replacementProductInfosByWishListLineId,
    });

    props.dispatch({
        type: "Pages/MyListDetails/SetAllWishListLinesIsSelected",
        isSelected: false,
    });

    if (props.apiResult) {
        props.dispatch({
            type: "Data/WishListLines/CompleteLoadWishListLines",
            parameter: props.dataViewParameter,
            result: props.apiResult,
        });
        props.dispatch({
            type: "Data/WishLists/CompleteLoadWishListLines",
            parameter: props.apiParameter,
            result: props.apiResult,
        });
    }
};

replaceInChain(chain, DispatchCompleteLoadWishListLines, XngDispatchCompleteLoadWishListLines);
